import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { FormControlLabel, Checkbox } from '@material-ui/core'
import * as css from './CheckboxInput.css'

const styles = (theme: CentricTheme) => ({
  root: {}
})

interface MyProps extends StyledProps {
  /** String for the name of the field */
  name: string
  /** String for the field's label */
  label?: React.ReactNode
  /** Boolean indicating whether the checkbox is checked or not */
  checked?: boolean
  /** Function to handle the onChange event */
  onChange?: (e, checked: boolean) => void
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
  /** Value */
  value?: string

  checkboxCss?: string
}

export class CheckboxInputComponent extends React.Component<MyProps> {
  static defaultProps = {
    value: '',
    name:     '',
    label:    '',
    checked:  false,
    onChange: () => {},
    disabled: false,
    checkboxCss: ''
  }

  render() {
    const {className, name, label, value, checked, onChange, disabled, checkboxCss} = this.props

    return (
      <FormControlLabel className={classNames(css.root, className)}
                        data-type='CheckboxInput'
        control={
          <Checkbox checked={checked}
                    onChange={onChange}
                    value={value}
                    name={name}
                    color='secondary'
                    data-type='Checkbox'
                    data-disabled={disabled}
                    disabled={disabled}
                    className={checkboxCss}
          />
        }
        label={label}
      />
    )
  }
}

@(withStyles as any)(styles)
export class CheckboxInput extends CheckboxInputComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/CheckboxInput.tsx